import { object } from "yup";

import { bigNumberValidationSchema } from "@dzambalaorg/yup-rules-eth";

export const amountValidationSchema = object().shape({
  amount: bigNumberValidationSchema.min(1, "form.validations.rangeUnderflow"),
});
